module.exports = __webpack_public_path__ + "static/media/col-detail-camicia@2x.002e2575.png";